import { all, fork } from "redux-saga/effects";
import userSaga from "./userSaga";
import kycSaga from "./kycSaga";
import kybSaga from "./kybSaga";
import calculateRiskSaga from "./calculateRiskSaga";

export default function* rootSaga() {
  yield all([
    fork(userSaga),
    fork(kycSaga),
    fork(kybSaga),
    fork(calculateRiskSaga),
  ]);
}
